import '@fancyapps/ui';
import {Fancybox} from "@fancyapps/ui";

window.fbox = Fancybox;

import './vue/index';

import {InitMaskedinput} from "./include/init-maskedinput";
import InitDatepicker from "./include/init-datepicker";
import {initExternalLib} from "./include/init-external-lib";
import './include/jquery-code';
import './include/init-sliders';
import './include/init-video';

new InitDatepicker();

import {Collapsible} from "./block/collapsible";
import {CollapseBlock} from "./block/collapseBlock";
import {RippleButton} from "./block/rippleButton";
import {CraftForms} from "./block/craftForms";
import {MobileHeader} from "./block/mobileHeader";
import {SmoothAnchor} from "./block/smoothAnchor";
import {ValueCapacitor} from "./block/valueCapacitor";
import {CustomDropdown} from "./block/customDropdown";
import {NewsFilter} from "./block/newsFilter";
import ClearInput from "./block/clearInput";
import BviTool from "./block/bviTool";
import {FancyHash} from "./block/fancyHash";

new Collapsible();
new CollapseBlock();
new RippleButton();
new MobileHeader();
new SmoothAnchor();
new ValueCapacitor();
new CustomDropdown();
new NewsFilter('.news-filter');
new CraftForms('.js-craft-form');
new ClearInput('.js-clear-input');
new BviTool();
new FancyHash();

Fancybox.bind("[data-fancybox]", {
    trapFocus: false,
    autoFocus: false,
    tpl: {
        closeButton: false,
    },
    on: {
        done: (fancybox, eventName) => {
            new InitDatepicker();
            new InitMaskedinput();
            new CraftForms('.js-craft-form');
            // new CustomDropdown();
            // new ValueCapacitor();
        },
    },
});


Fancybox.bind("[data-fancybox-buy]", {
    trapFocus: false,
    autoFocus: false,
    tpl: {
        closeButton: false,
    },
    on: {
        done: (fancybox, eventName) => {
            initExternalLib.withPromise(`https://lk.sistemagorod.ru/f4bacb58/js/api.js`).then(result => {
                let containerOplata = document.getElementById("modal-oplata");
                SGB.renderWidget(containerOplata, {
                    providerGuid: "F4BACB58-39F3-49C5-BB00-522D37DEF16C",
                    widgetType: "payments",
                    test: "true",
                    width: "310",
                    height: "300"
                });
            });

        },
    },
});


Fancybox.bind("[data-fancybox-metric]", {
    trapFocus: false,
    autoFocus: false,
    tpl: {
        closeButton: false,
    },
    on: {
        done: (fancybox, eventName) => {
            initExternalLib.withPromise(`https://lk.sistemagorod.ru/f4bacb58/js/api.js`).then(result => {
                let containerPokazaniya = document.getElementById("modal-pokazaniya");
                SGB.renderWidget(containerPokazaniya, {
                    providerGuid: "F4BACB58-39F3-49C5-BB00-522D37DEF16C",
                    widgetType: "counters",
                    test: "true",
                    width: "310",
                    height: "300"
                });
            });
        },
    },
});
